define.alias("shared/utils/is-popup-window", "settings/utils/is-popup-window");